import React, { useMemo, useState } from 'react';
import { Avatar } from '@mui/material';
import { ImageDialog } from 'components';
import { InfluencerTypes } from 'api';
import { getInfluencerName, getUserInitials } from 'helpers/common';

interface Props {
  data: InfluencerTypes.ItemExtended;
}

const InfluencerAvatar = (props: Props): JSX.Element => {
  const { data } = props;

  const initials = useMemo(
    () => getUserInitials(getInfluencerName(data)),
    [data],
  );

  const [isOpen, setIsOpen] = useState(false);

  const handleOpenDialog = () => {
    setIsOpen(true);
  };

  const handleCloseDialog = () => {
    setIsOpen(false);
  };

  const image = data.profile_picture_url;

  return (
    <>
      <Avatar
        src={image}
        sx={{
          width: '100px',
          height: '100px',
          cursor: image ? 'pointer' : 'default',
        }}
        {...(image && { onClick: handleOpenDialog })}
      >
        {initials}
      </Avatar>
      {image && (
        <ImageDialog
          isOpen={isOpen}
          onClose={handleCloseDialog}
          influencerData={data}
        />
      )}
    </>
  );
};

export default InfluencerAvatar;
